import React from 'react';
import { Box, Container, Typography, Stack } from '@mui/material';

const CancellationPolicy = () => {
    return (
        <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 10 }}>
            <Container maxWidth="md">
                <Typography variant="h3" sx={{ fontWeight: 900, mb: 6 }}>Cancellation Policy</Typography>
                <Stack spacing={4} sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>1. Cancelling Your Subscription</Typography>
                        <Typography variant="body1">
                            You can cancel your paid subscription at any time from the Billing page in your account
                            dashboard, or by contacting support@socialixer.com. There is no cancellation fee.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>2. When Cancellation Takes Effect</Typography>
                        <Typography variant="body1">
                            Cancellation takes effect at the end of your current billing period. You will retain full access
                            to all paid features and any remaining AI quota until that date. No partial refund is issued
                            for the unused portion of the current billing cycle.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>3. After Cancellation</Typography>
                        <Typography variant="body1">
                            Once the current billing period ends, your account will automatically revert to the free tier.
                            Your data, connected social accounts, and scheduled posts will be retained. Top-up credits
                            purchased separately remain available on your account and do not expire on cancellation.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>4. Reactivating Your Subscription</Typography>
                        <Typography variant="body1">
                            You can resume a paid subscription at any time by visiting the Billing page and choosing a
                            plan. Reactivation starts a new billing cycle from the date of resubscription.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>5. Account Deletion</Typography>
                        <Typography variant="body1">
                            If you wish to permanently delete your account and all associated data, contact
                            support@socialixer.com. Account deletion is irreversible and will remove all your content,
                            credentials, and analytics history within 30 days of the request.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>6. Refunds on Cancellation</Typography>
                        <Typography variant="body1">
                            Cancelling a subscription does not automatically trigger a refund. Refund eligibility is
                            governed by our Refund Policy, including the 7-day window for first-time paid subscriptions.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>7. Contact</Typography>
                        <Typography variant="body1">
                            For any questions about cancellation, contact us at support@socialixer.com.
                        </Typography>
                    </Box>
                </Stack>
            </Container>
        </Box>
    );
};

export default CancellationPolicy;
